var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-3", attrs: { md: "7" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "text-center",
                  attrs: { "label-cols-sm": "3", "label-align-sm": "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [_vm._v("Units")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("unit-selector", {
                    attrs: { size: "lg" },
                    model: {
                      value: _vm.displayUnit,
                      callback: function ($$v) {
                        _vm.displayUnit = $$v
                      },
                      expression: "displayUnit",
                    },
                  }),
                ],
                1
              ),
              _c("hr"),
              _c(
                "b-form-group",
                {
                  attrs: { "label-cols-lg": "3", "label-align-lg": "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("External Size\n"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_c("em", [_vm._v("(frame size)")])]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    { staticClass: "pl-3 pt-1" },
                    [
                      _c("size-input", {
                        attrs: {
                          unit: _vm.displayUnit,
                          size: "lg",
                          valid: _vm.validate.external,
                          readonly: "",
                        },
                        model: {
                          value: _vm.externalSize,
                          callback: function ($$v) {
                            _vm.externalSize = $$v
                          },
                          expression: "externalSize",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-cols-lg": "3",
                    "label-align-lg": "right",
                    description:
                      "Please note the internal size is the standard size -3mm on each side to ensure your standard size artwork does not fall through.",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("Internal Size\n"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_c("em", [_vm._v("(aperture size)")])]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    { staticClass: "pl-3 pt-1" },
                    [
                      _c("size-input", {
                        attrs: {
                          unit: _vm.displayUnit,
                          size: "lg",
                          valid: _vm.validate.aperture,
                          readonly: "",
                        },
                        model: {
                          value: _vm.apertureSize,
                          callback: function ($$v) {
                            _vm.apertureSize = $$v
                          },
                          expression: "apertureSize",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("hr"),
              _c(
                "b-form-group",
                {
                  attrs: { "label-cols-lg": "3", "label-align-lg": "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("Border Widths\n"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_c("em", [_vm._v("(calculated)")])]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    { staticClass: "pl-3 pt-1" },
                    [
                      _c("size-input", {
                        attrs: {
                          unit: _vm.displayUnit,
                          readonly: "",
                          size: "lg",
                          valid: _vm.validate.borders,
                        },
                        model: {
                          value: _vm.borderSizes,
                          callback: function ($$v) {
                            _vm.borderSizes = $$v
                          },
                          expression: "borderSizes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("hr"),
              _c(
                "b-form-group",
                {
                  attrs: { "label-cols-sm": "3", "label-align-sm": "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [_vm._v("Colours")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("mountboard-colours", {
                    model: {
                      value: _vm.selectedBoard,
                      callback: function ($$v) {
                        _vm.selectedBoard = $$v
                      },
                      expression: "selectedBoard",
                    },
                  }),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/cut-to-size-picture-mounts/order-samples",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "Not sure of the correct colour to choose for your mount?  Order colour samples here."
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("hr"),
              _c("p", [
                _vm._v("Please note that the photo mount will be cut to the "),
                _c("strong", [_vm._v("exact")]),
                _vm._v(" dimensions you enter."),
                _c("br"),
                _vm._v(
                  " This means that if you enter the exact size of your artwork, it will fall through the aperture.\n"
                ),
                _c("br"),
                _vm._v(
                  ' We have subtracted 3mm (1/8") from each internal side to ensure your artwork is secure behind the mountboard.\n'
                ),
                _c("br"),
                _vm._v(
                  " The standard sized mounts offered on our website already have this 3mm subtracted from their aperture."
                ),
              ]),
              _c("hr"),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-cols-sm": "6",
                            "label-align-sm": "right",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [_vm._v("Quantity")]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "number",
                              min: "1",
                              step: "1",
                              state: _vm.validate.quantity,
                            },
                            model: {
                              value: _vm.quantity,
                              callback: function ($$v) {
                                _vm.quantity = _vm._n($$v)
                              },
                              expression: "quantity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("undermount-selector", {
                        attrs: { price: _vm.calcUndermountPrice },
                        model: {
                          value: _vm.includeUndermount,
                          callback: function ($$v) {
                            _vm.includeUndermount = $$v
                          },
                          expression: "includeUndermount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c(
                        "b-overlay",
                        { attrs: { show: _vm.loading } },
                        [
                          _c("mount-order-breakdown", {
                            attrs: {
                              "is-valid": _vm.validationStrings.length === 0,
                              "external-size": _vm.externalSize,
                              "aperture-size": _vm.apertureSize,
                              "include-undermount": _vm.includeUndermount,
                              board: _vm.selectedBoard,
                              "undermount-price":
                                _vm.withUndermountPricing.unit_price,
                              "mount-price": _vm.mountPricing.unit_price,
                              quantity: _vm.quantity,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.validationStrings.length > 0,
                    variant: "danger",
                  },
                },
                [
                  _c("p", { staticClass: "mb-2" }, [
                    _c("strong", [
                      _vm._v(
                        "Sorry, this product is currently unavailable for the following reasons:"
                      ),
                    ]),
                  ]),
                  _vm._l(_vm.validationStrings, function (string, idx) {
                    return _c("p", { key: idx, staticClass: "mb-1" }, [
                      _vm._v(_vm._s(string)),
                    ])
                  }),
                ],
                2
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6", "offset-sm": "6" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            variant:
                              _vm.validationStrings.length > 0
                                ? `danger`
                                : `success`,
                            block: "",
                            size: "lg",
                            disabled: _vm.isAddToCartDisabled,
                          },
                          on: { click: _vm.addToCart },
                        },
                        [
                          _c("i", { staticClass: "material-icons mr-2" }, [
                            _vm._v("shopping_cart"),
                          ]),
                          _vm._v(
                            "Add to Cart\n(£" +
                              _vm._s(_vm.totalPrice) +
                              " " +
                              _vm._s(_vm.vatMode) +
                              " VAT)"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-col", { staticClass: "text-center", attrs: { md: "5" } }, [
            _c(
              "div",
              { staticClass: "sticky-top pt-3" },
              [
                _c("mount-vis", {
                  staticClass: "mb-3",
                  attrs: {
                    colour: _vm.selectedBoard
                      ? `#${_vm.selectedBoard.dominant_colour}`
                      : "#fefefe",
                    "external-size": _vm.externalSize,
                    "aperture-size": _vm.apertureSize,
                  },
                }),
                _c(
                  "b-row",
                  { attrs: { "align-h": "center" } },
                  [
                    _c("b-col", { attrs: { sm: "8" } }, [
                      _c("picture", [
                        _c("source", {
                          attrs: {
                            srcset: require("@/img/site/larson-juhl-logo.jpg?format=webp"),
                            type: "image/webp",
                          },
                        }),
                        _c("source", {
                          attrs: {
                            srcset: require("@/img/site/larson-juhl-logo.jpg"),
                            type: "image/jpeg",
                          },
                        }),
                        _c("img", {
                          attrs: {
                            src: require("@/img/site/larson-juhl-logo.jpg"),
                            type: "image/jpeg",
                          },
                        }),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c("p", { staticClass: "text-center mb-2 mt-3" }, [
                  _vm._v(
                    "We also offer this mount in custom sizes up to 815x1120mm."
                  ),
                ]),
                _c(
                  "b-button",
                  { staticClass: "btn-brand", attrs: { href: _vm.bespokeUrl } },
                  [_vm._v("Configure and buy a custom sized mount")]
                ),
                _c(
                  "b-row",
                  {
                    staticClass: "text-left mt-3",
                    attrs: { "align-h": "center" },
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "9" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "mb-3" },
                          [
                            _c("h4", [_vm._v("Volume Discounts")]),
                            _c("p", [
                              _vm._v("The more you buy, the more you save!"),
                            ]),
                            _c("discounts-breakdown", {
                              attrs: {
                                "item-type": "Mount",
                                "sku-prefix": "MCTS",
                                price: _vm.exVatUnitPrice,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }